export enum ExportFormatEnum {
  CSV = 'CSV',
  PDF = 'PDF',
  PPTX = 'PPTX'
}

export type ExportFormat = keyof typeof ExportFormatEnum

export enum ExportCsvSeparatorEnum {
  comma = 'comma',
  semicolon = 'semicolon'
}

export type ExportCsvSeparator = keyof typeof ExportCsvSeparatorEnum
